import { Todo } from 'api/clients/TodoClient'
import { useAuth } from 'hooks/UseAuth'

export const useTodoPermissions = (todo: Todo, inCleanupMode: boolean = false) => {
  const auth = useAuth()
  const isAuthor = auth && auth?.id === todo.creator.id
  const isAssignee = auth && auth?.id === todo.assignee?.id

  const cleanupPermissions = {
    canEdit: false,
    canReact: true,
    canDelete: false,
    canAssign: false,
    canToggleResolve: true,
    canChangeDueDate: false,
    canChangeDescription: false,
  }

  if (inCleanupMode) return cleanupPermissions

  return {
    canEdit: isAuthor,
    canReact: true,
    canDelete: isAuthor,
    canAssign: isAuthor,
    canToggleResolve: isAuthor || isAssignee,
    canChangeDueDate: isAuthor,
    canChangeDescription: isAuthor,
  }
}
